import { officeBreakdownTab } from ".";
import { Routes } from "../../common/routes/routes";

export const baseRoute = `${Routes.MARKET_DYNAMICS.BASE}`;
export const officeBreakdownRoute = `${baseRoute}${Routes.MARKET_DYNAMICS.OFFICES_BREAKDOWN}`;
export const listingsBreakdownRoute = `${baseRoute}${Routes.MARKET_DYNAMICS.LISTINGS_BREAKDOWN}`;
export const officeListingsRoute = `${baseRoute}${Routes.MARKET_DYNAMICS.OFFICE_LISTING}`;

export const getBreakdownRoute = (currentTab) => {
    if (currentTab === officeBreakdownTab) return officeBreakdownRoute;
    return listingsBreakdownRoute;
};
